module.exports = __webpack_public_path__ + "img/p2-74.16fd1dac.png";